'use strict';

const userInteraction = [
  '$document',
  '$rootScope',
  'throttle',

  function ($document, $rootScope, throttle) {
    var callCount = 0;
    var emit = throttle(function emit() {
      $rootScope.$emit('userInteraction');
    }, 300, { trailing: false });

    return {
      startListening: function () {
        if (!callCount) {
          $document.on('mousemove', emit);
          $document.on('touchstart', emit);
          $document.on('keydown', emit);
        }

        callCount++;
      },
      stopListening: function () {
        callCount = Math.min(callCount - 1, 0);

        if (!callCount) {
          $document.off('mousemove', emit);
          $document.off('touchstart', emit);
          $document.off('keydown', emit);
        }
      }
    };
  }
];

export default userInteraction;



// WEBPACK FOOTER //
// ./app/src/services/user_interaction.js